<template>
<div class="chapter">
<div class="inner_page">
<p class="p7"><span class="t9">By</span> R<span class="t10">EMMY</span> D<span class="t10">UCHENE</span></p>
<p class="p0"><span class="t9">Captive to His Wonder</span></p>
<p class="p0"><span class="t9">Deliver Me</span></p>
<p class="p0"><span class="t11">With Allison Cassatta</span><span class="t9">:</span><span class="t11"> </span><span class="t9">This is Love</span></p>
<p class="p8"><span class="t11">With BLMorticia</span><span class="t9">: Wounded Hearts</span></p>
<p class="p0"><span class="t9">Published b</span>y D<span class="t10">REAMSPINNER</span> P<span class="t10">RESS</span></p>
<p class="p8"><span class="t9">http://www.dreamspinnerpress.com</span></p>
<p class="p1"><span class="t9">By</span> BLM<span class="t10">ORTICIA</span></p>
<p class="p8"><span class="t11">With Remmy Duchene</span><span class="t9">: Wounded Hearts</span></p>
<p class="p0"><span class="t9">Published by</span> D<span class="t10">REAMSPINNER</span> P<span class="t10">RESS</span></p>
<p class="p0"><span class="t9">http://www.dreamspinnerpress.com</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003.vue?5ce21f74